import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TestAssignment } from '../../interfaces/test-assignment';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../../interfaces/responses/api-response';

/**
 * Student-side endpoints for test assignments (devoirs / examens reçus).
 * Auto-scoped via JWT — returns only assignments targeting the current student
 * (direct, via group, or via subject).
 *
 * Only `active` assignments are returned.
 *
 * Endpoints:
 *   GET /api/students/me/test-assignments
 *   GET /api/students/me/test-assignments/{id}
 *   GET /api/students/me/test-assignments/by-subject/{subjectId}
 */
@Injectable({ providedIn: 'root' })
export class StudentTestAssignmentService {
  private readonly base = `${environment.BASE_URL}/students/me/test-assignments`;

  constructor(private http: HttpClient) {}

  /** All active assignments targeting the current student. */
  myAssignments(): Observable<ApiCollectionResponse<TestAssignment>> {
    return this.http.get<ApiCollectionResponse<TestAssignment>>(this.base);
  }

  getById(id: number): Observable<ApiSingleResponse<TestAssignment>> {
    return this.http.get<ApiSingleResponse<TestAssignment>>(
      `${this.base}/${id}`,
    );
  }

  bySubject(subjectId: number): Observable<ApiCollectionResponse<TestAssignment>> {
    return this.http.get<ApiCollectionResponse<TestAssignment>>(
      `${this.base}/by-subject/${subjectId}`,
    );
  }
}
